export const FETCH_EASY_JOIN_CODES_START = 'FETCH_EASY_JOIN_CODES_START';
export const FETCH_EASY_JOIN_CODES_FULFILLED = 'FETCH_EASY_JOIN_CODES_FULFILLED';
export const FETCH_EASY_JOIN_CODES_REJECTED = 'FETCH_EASY_JOIN_CODES_REJECTED';

export const CREATE_EASY_JOIN_CODE_START = 'CREATE_EASY_JOIN_CODE_START';
export const CREATE_EASY_JOIN_CODE_FULFILLED = 'CREATE_EASY_JOIN_CODE_FULFILLED';
export const CREATE_EASY_JOIN_CODE_REJECTED = 'CREATE_EASY_JOIN_CODE_REJECTED';

export const UPDATE_EASY_JOIN_CODE_START = 'UPDATE_EASY_JOIN_CODE_START';
export const UPDATE_EASY_JOIN_CODE_FULFILLED = 'UPDATE_EASY_JOIN_CODE_FULFILLED';
export const UPDATE_EASY_JOIN_CODE_REJECTED = 'UPDATE_EASY_JOIN_CODE_REJECTED';

export const DELETE_EASY_JOIN_CODES_START = 'DELETE_EASY_JOIN_CODES_START';
export const DELETE_EASY_JOIN_CODES_FULFILLED = 'DELETE_EASY_JOIN_CODES_FULFILLED';
export const DELETE_EASY_JOIN_CODES_REJECTED = 'DELETE_EASY_JOIN_CODES_REJECTED';

export const EASY_JOIN_CLEAR_LAST_CREATED = 'EASY_JOIN_CLEAR_LAST_CREATED';
export const EASY_JOIN_CLEAR_LAST_UPDATED = 'EASY_JOIN_CLEAR_LAST_UPDATED';
